import styled, { css } from "styled-components"
import { lighten } from "global/theme"

export const GooglePlacesAutoCompleteWrapper = styled.div`
    width: 100%;
    margin-bottom: 2rem;
`

export const PlaceAutocomplete = styled.input`
  height: 5rem;
  border: solid 0.1rem ${(props) => props.theme.color.lightGray};
  color: ${(props) => props.theme.color.secondaryText};
  border-radius: 0.4rem;
  background: ${(props) => props.theme.color.white};
  padding: 0 1.7rem;
  font-size: 1.6rem;
  font-weight: ${(props) => props.theme.fontWeights.normal};
  width: 100%;
  outline: none;
  opacity: 1;
  -webkit-appearance: none;
  -moz-appearance: textfield;
  position: relative;

  &:focus {
    border-color: ${(props) => props.theme.color.primaryAccent};
    z-index: ${(props) => props.theme.zIndices.minimal};
  }

  &::placeholder {
    color: ${(props) => lighten(props.theme.color.secondaryText, 0.5)};
  }

  ::-webkit-search-cancel-button,
  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`
export const PlacesList = styled.div`
  border: solid 0.1rem ${(props) => props.theme.color.lightGray};
  color: ${(props) => props.theme.color.secondaryText};
  border-radius: 0.4rem;
  background: ${(props) => props.theme.color.white};
  padding: 0 1.9rem;
  font-size: 1.6rem;
  font-weight: ${(props) => props.theme.fontWeights.book};
  width: 100%;
  outline: none;
  opacity: 1;
  -webkit-appearance: none;
  -moz-appearance: none;
  position: relative;

  ${p =>
    p.empty &&
    css`
      color: ${(props) => lighten(props.theme.color.secondaryText, 0.5)};
    `}
  &::-ms-expand {
    display: none;
  }

  &::-moz-focus-inner,
  &:-moz-focusring {
    color: transparent !important;
    text-shadow: 0 0 0 #000 !important;
    background-image: none !important;
  }

  &:focus {
    border-color: ${(props) => props.theme.color.primaryAccent};
    z-index: ${(props) => props.theme.zIndices.minimal};
  }
`



// WEBPACK FOOTER //
// ./src/pages/AffiliateRegistration/AffiliateSelector/PlaceSearch/styled.js